import { createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from '../../apis'
import axios from 'axios';

import LocalStorage from "../../utils/storage";

const ROLE = LocalStorage.getItem('userRole');

export const getMasterAllocationTasks = createAsyncThunk('getMasterAllocationTasks', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/tasks`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const calculateMasterAllocation = createAsyncThunk('calculateMasterAllocation', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/calculate`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const createMasterAllocation = createAsyncThunk('createMasterAllocation', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/create`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const getOutwardStyles = createAsyncThunk('getOutwardStyles', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/${data?.task_id}/outwards`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const submitOutwardStyles = createAsyncThunk('submitOutwardStyles', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/${data?.task_id}/outwards/submit`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const shortlistOutwardStyles = createAsyncThunk('shortlistOutwardStyles', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/${data?.task_id}/outwards/shortlist`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const removeShortlistedProducts = createAsyncThunk('removeShortlistedProducts', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/${data?.task_id}/outwards/remove`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const rejectAllocationTasks = createAsyncThunk('rejectAllocationTasks', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/${data?.task_id}/reject`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const getOutwardSummary = createAsyncThunk('getOutwardSummary', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/${data?.task_id}/outwards/summary`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const getPendingStoreInwards = createAsyncThunk('getPendingStoreInwards', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/pending-store-inwards/fetch`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const getStyles = createAsyncThunk('getStyles', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/${data?.task_id}/styles`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const shortlistStyles = createAsyncThunk('shortlistStyles', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/${data?.task_id}/styles/shortlist`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const submitStyles = createAsyncThunk('submitStyles', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/${data?.task_id}/submit`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const removeShortlistedStyles = createAsyncThunk('removeShortlistedStyles', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/${data?.task_id}/styles/remove`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const createGatepass = createAsyncThunk('createGatepass', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/${data?.task_id}/gatepasses/create`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const getSummary = createAsyncThunk('getSummary', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/${data?.task_id}/summary`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const createBulkUpload = createAsyncThunk('createBulkUpload', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/create/bulk-upload`
  let bodyFormData = new FormData();
  bodyFormData.append('file', data.file);
  try {
    const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
    return response
  } catch (error) {
    return handleErrorResponse(error, rejectWithValue)
  }
});

export const downlaodOutwards = createAsyncThunk('downlaodOutwards', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/outwards/download`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'outwards_download_file.xlsx'; // Default filename if none is found
        if (contentDisposition && contentDisposition.includes('attachment')) {
            const matches = /filename=([^"]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
            filename = matches[1];
            }
        }
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const downloadBulkUploadSample = createAsyncThunk('downloadBulkUploadSample', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/bulk-upload/download-sample`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'bulk_upload_sample.xlsx'; // Default filename if none is found
        if (contentDisposition && contentDisposition.includes('attachment')) {
            const matches = /filename=([^"]*)/.exec(contentDisposition);
            console.log(matches)
            if (matches != null && matches[1]) {
            filename = matches[1];
            }
        }
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const downloadAllocationSummary = createAsyncThunk('downloadAllocationSummary', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/master-allocation/${data?.task_id}/summary/download`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'summary.xlsx'; // Default filename if none is found
        if (contentDisposition && contentDisposition.includes('attachment')) {
            const matches = /filename=([^"]*)/.exec(contentDisposition);
            console.log(matches)
            if (matches != null && matches[1]) {
            filename = matches[1];
            }
        }
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});
